import * as apiTo from '@/modular-api'

const initialState = () => ({
  templates: []
})

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    setTemplates: (state, payload) => (state.templates = payload),
    addNewTemplate: (state, payload) => state.templates.push(payload),
    templateUpdated: (state, payload) => {
      const index = state.templates.findIndex(t => t.id === payload.id)
      if (~index) state.templates.splice(index, 1, payload)
    },
    templateDeleted: (state, templateId) => {
      const index = state.templates.findIndex(t => t.id === templateId)
      if (~index) state.templates.splice(index, 1)
    },
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetTemplates({ commit }) {
      return apiTo.GET_TODOS_TEMPLATES().then(({ data }) => commit('setTemplates', data.result))
    },

    deleteTemplate({ commit }, templateId) {
      return apiTo.DELETE_TODO(templateId).then(() => commit('templateDeleted', templateId))
    }
  }
}
